import { createStore } from 'satcheljs';
export default createStore('quickSuggestionsOption', {
    smartSuggestionsEnabled: null,
    browserLocationEnabled: null,
})();
//# sourceMappingURL=store.js.map